export * from "./types.js";
export * from "./copy.js";
export {
  ftbEntitlement,
  ftbEligibilityGap,
  familyDebtRisk,
  baseRateCutoff,
} from "./calculate.js";
export { rates_2025_09_20 } from "./rates-2025-09-20.js";

import type { FamilyPaymentsRuleSet } from "./types.js";
import { rates_2025_09_20 } from "./rates-2025-09-20.js";

/**
 * Registry of family-payments rate periods, keyed by `periodKey` (an indexation
 * date — Services Australia indexes FTB on 20 Mar / 20 Sep, not 1 July). New
 * indexations register a new period alongside this one; historical periods stay
 * registered so a reconciliation resolves against the rates in force then.
 */
export const FAMILY_PAYMENTS_RATESETS: Record<string, FamilyPaymentsRuleSet> = {
  "2025-09-20": rates_2025_09_20,
};

/** All registered periods, sorted newest-first for date resolution. */
const PERIODS: readonly FamilyPaymentsRuleSet[] = Object.values(
  FAMILY_PAYMENTS_RATESETS,
).sort((a, b) => (a.effectiveFrom < b.effectiveFrom ? 1 : -1));

/** Resolve a family-payments rate period by its registry key, or throw. */
export function familyPaymentsRatesFor(periodKey: string): FamilyPaymentsRuleSet {
  const rules = FAMILY_PAYMENTS_RATESETS[periodKey];
  if (!rules) {
    throw new Error(`no family-payments rate period registered for ${periodKey}`);
  }
  return rules;
}

/**
 * Pick the family-payments rate period in force on an ISO date (YYYY-MM-DD).
 * Pure string comparison — ISO dates sort lexically. The current period is
 * open-ended (`effectiveTo: null`). Throws if the date predates every period.
 */
export function familyPaymentsRatesForDate(date: string): FamilyPaymentsRuleSet {
  for (const p of PERIODS) {
    const inWindow =
      date >= p.effectiveFrom && (p.effectiveTo === null || date <= p.effectiveTo);
    if (inWindow) return p;
  }
  throw new Error(`no family-payments rate period registered for date ${date}`);
}

/** Most recent family-payments rate period — the default for live calcs. */
export const FAMILY_PAYMENTS_CURRENT_PERIOD = "2025-09-20";
